import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { TextBody } from 'web-ui-components/lib/atoms/text';
import { Field, FieldHeader, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { Checkbox } from 'web-ui-components/lib/atoms/forms';
import content, { contentPropTypes } from './PaymentsDateSelector.content';
import withContent from '../../../../containers/withContent';
import DateField from '../../../../sharedComponents/DateField/DateField';
import { dateFormat } from '../../../../config';
import withValidation from '../../../../containers/withValidation';

export const PaymentsDateSelector = ({
	content: { header, description, urgentPaymentLabel, urgentPaymentInfo, invalidValidationMessage },
	paymentDates = [],
	onChange,
	onCheckboxChange,
	isUrgentPaymentChecked,
	date = '',
	isValid,
	showValidation,
	disabled,
}) => {
	const showErrorMsg = !isValid && showValidation;
	return (
		<Field>
			<FieldHeader name="payment-date" titleText={header} description={description} />
			<DateField
				id="field-payment-date"
				className="c-o-list-payment__input-with-fix"
				dateFormat={dateFormat}
				onChange={onChange}
				includeDates={paymentDates}
				selectedDate={date}
			/>
			{showErrorMsg && <ValidationMessage hasIcon={false} value={invalidValidationMessage} />}
			<Checkbox
				checked={isUrgentPaymentChecked}
				id="urgent-checkbox"
				label={urgentPaymentLabel}
				onChange={onCheckboxChange}
				disabled={disabled}
			/>
			<TextBody>{urgentPaymentInfo}</TextBody>
		</Field>
	);
};

PaymentsDateSelector.propTypes = {
	content: PropTypes.shape(contentPropTypes),
	isUrgentPaymentChecked: PropTypes.bool.isRequired,
	paymentDates: PropTypes.arrayOf(PropTypes.shape({})),
	onChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	date: PropTypes.shape({}),
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	disabled: PropTypes.bool,
};
const validation = withValidation({
	validations: ['date'],
	key: 'date',
	message: 'Please select one of the options.',
});
export default compose(withContent({ content }), validation)(PaymentsDateSelector);
